import { render } from "./ItemListByBranch.vue?vue&type=template&id=fd883e70&scoped=true"
import script from "./ItemListByBranch.vue?vue&type=script&lang=js"
export * from "./ItemListByBranch.vue?vue&type=script&lang=js"

import "./ItemListByBranch.vue?vue&type=style&index=0&id=fd883e70&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd883e70"]])

export default __exports__